import React, { Component } from "react"
export default class extends Component {
    render() {
        return (
            <a href="#" id="scroll-to-top" className="dmtop global-radius"><i className="fa fa-angle-up"></i></a>
        )
    }
}